/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React  from 'react';
// material
import Space from 'material/space/space';
// content
// styles
import injectSheet from 'react-jss'
import styles from './togglebutton_styles'


/* ========== ~~~~~~~~~~ TOGGLES COMPONENT ~~~~~~~~~~ ========== */
const ToggleButton = injectSheet(styles)((props) => {

  const { items, selected, onChange } = props

  return (
    <Space klass={`togglebutton ${props.classes.togglebutton}`}>
      {items.map(item => <div className={`active-${selected === item.value}`} onClick={() => onChange(item)}>{item.label}</div>)}
    </Space>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ToggleButton;